import { render, staticRenderFns } from "./ChatLeft.vue?vue&type=template&id=06587184&scoped=true&"
import script from "./ChatLeft.vue?vue&type=script&lang=js&"
export * from "./ChatLeft.vue?vue&type=script&lang=js&"
import style0 from "./ChatLeft.vue?vue&type=style&index=0&id=06587184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06587184",
  null
  
)

export default component.exports